// src/components/dashboard/charts/ChartHeader.js
import React from 'react';

const ChartHeader = ({ title, className = '' }) => (
  <div className={`text-center mb-4 sm:mb-6 ${className}`}>
    <h4 className="text-sm sm:text-base md:text-lg font-semibold text-content-primary mb-2">{title}</h4>
    <div className="w-12 h-0.5 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full" />
  </div>
);

export default ChartHeader;
